import { render, staticRenderFns } from "./ModalSuspenderCompraDireta.vue?vue&type=template&id=0ba27e70&scoped=true"
import script from "./ModalSuspenderCompraDireta.vue?vue&type=script&lang=js"
export * from "./ModalSuspenderCompraDireta.vue?vue&type=script&lang=js"
import style0 from "./ModalSuspenderCompraDireta.vue?vue&type=style&index=0&id=0ba27e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba27e70",
  null
  
)

export default component.exports